var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-dd"},[_c('div',{staticClass:"stars"},_vm._l((5),function(i){return _c('span',{key:i,class:{ selected: _vm.starValue >= i },on:{"click":function($event){_vm.starValue = i}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }